import { FC } from 'react'
import TooltipProvider from './TooltipProvider'

import { t } from 'translations'

const CostIcon: FC = () => {
  return (
    <TooltipProvider tooltip={t(`manager.COST_WARNING`)}>
      <i className="fa-regular fa-circle-dollar" />
    </TooltipProvider>
  )
}

export default CostIcon
